// extracted by mini-css-extract-plugin
export default {"info":"style_info__yd2Zd","time-line":"style_time-line__oTKHo"};